import React, { Fragment, Suspense } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Max_404_page from "./Components/NotFound";
import "react-toastify/dist/ReactToastify.css";
import { routeMap } from "./routeMap";
import Loading from "./Components/Loading";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <Router>
      <ToastContainer autoClose={1000} pauseOnFocusLoss={false} />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          {routeMap?.map((ele, index) => {
            const Layout = ele?.layout || Fragment;
            const Component = ele?.element;
            return (
              <Route
                path={ele?.path}
                key={index}
                element={
                  <Layout>
                    <Component />
                  </Layout>
                }
              />
            );
          })}
          <Route path="/*" element={<Max_404_page />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
